module.exports = __webpack_public_path__ + "static/assets/e2559f595c0c3b13891fe2567931dca7.png";